import { useAllLoyaltyExternalOffersQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useLoyaltyExternalOffers = (skip?: boolean) => {
  const { featureLoyaltyExternalOffersId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useAllLoyaltyExternalOffersQuery({
    variables: {
      id: featureLoyaltyExternalOffersId,
    },
    skip: skip || !featureLoyaltyExternalOffersId,
  });

  const externalOffers = data?.LoyaltyLiveExternalOffers?.liveExternalOffers;

  return {
    externalOffers,
    externalOffersLoading: loading || featureIdsLoading,
  };
};
